/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_Verify_Unlock_DescInputs */

const en_student_verify_unlock_desc = /** @type {(inputs: Student_Verify_Unlock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify your university email to access the Student plan at EUR 14.99/mo`)
};

const de_student_verify_unlock_desc = /** @type {(inputs: Student_Verify_Unlock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiziere deine Universitaets-E-Mail, um den Studenten-Plan fuer EUR 14,99/Monat freizuschalten`)
};

const fr_student_verify_unlock_desc = /** @type {(inputs: Student_Verify_Unlock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifie ton e-mail universitaire pour acceder au plan Etudiant a EUR 14,99/mois`)
};

const es_student_verify_unlock_desc = /** @type {(inputs: Student_Verify_Unlock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica tu correo universitario para acceder al plan Estudiante por EUR 14,99/mes`)
};

const it_student_verify_unlock_desc = /** @type {(inputs: Student_Verify_Unlock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica la tua email universitaria per accedere al piano Studente a EUR 14,99/mese`)
};

const nl_student_verify_unlock_desc = /** @type {(inputs: Student_Verify_Unlock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifieer je universiteitsemail om het Studentenplan voor EUR 14,99/maand te ontgrendelen`)
};

const pl_student_verify_unlock_desc = /** @type {(inputs: Student_Verify_Unlock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweryfikuj swoj e-mail uniwersytecki, aby uzyskac dostep do planu Studenckiego za EUR 14,99/mies.`)
};

const fi_student_verify_unlock_desc = /** @type {(inputs: Student_Verify_Unlock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvista yliopiston sahkopostisi saadaksesi Opiskelijasuunnitelman hintaan EUR 14,99/kk`)
};

const da_student_verify_unlock_desc = /** @type {(inputs: Student_Verify_Unlock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræft din universitetsmail for at få adgang til Studerendeplanen til EUR 14,99/md`)
};

const sv_student_verify_unlock_desc = /** @type {(inputs: Student_Verify_Unlock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiera din universitetsmejl för att få tillgång till Studentplanen för EUR 14,99/mån`)
};

/**
* | output |
* | --- |
* | "Verify your university email to access the Student plan at EUR 14.99/mo" |
*
* @param {Student_Verify_Unlock_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const student_verify_unlock_desc = /** @type {((inputs?: Student_Verify_Unlock_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_Verify_Unlock_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_student_verify_unlock_desc(inputs)
	if (locale === "fr") return fr_student_verify_unlock_desc(inputs)
	if (locale === "es") return es_student_verify_unlock_desc(inputs)
	if (locale === "it") return it_student_verify_unlock_desc(inputs)
	if (locale === "nl") return nl_student_verify_unlock_desc(inputs)
	if (locale === "pl") return pl_student_verify_unlock_desc(inputs)
	if (locale === "fi") return fi_student_verify_unlock_desc(inputs)
	if (locale === "da") return da_student_verify_unlock_desc(inputs)
	if (locale === "sv") return sv_student_verify_unlock_desc(inputs)
	return en_student_verify_unlock_desc(inputs)
});